/* eslint-env browser */

(function() {
  'use strict';


  var headerHeight;


  var setup = function(){
    headerHeight = $('header').outerHeight() + 20;
    // $('body').scrollspy({ 
    //   target: '#nav-spy',
    //   offset: headerHeight + 50,
    // });



    // let target = document.querySelector("#a03");
    // target.scrollIntoView({
    //     behavior: 'smooth',
    //     block: 'start'
    // });






    if (window.innerWidth > 440 && window.innerHeight > 440){
      $('main').css("margin-top", headerHeight);
    } else {
      $('main').css("margin-top", 0);
    }


    $("[data-fancybox]").fancybox({
        transitionEffect : "slide",
        toolbar : false,
        protect: true
    });
    
    
  }


  $(function() {
    //console.log($('#nav-spy')[0] );
    
    var isTouchDevice = 'ontouchstart' in document.documentElement;
    if (isTouchDevice) $("body").addClass('touch');

    setup();

    $( window ).resize(setup);




    $(".list-group a[href^='#']").on('click', function(e) {

       // prevent default anchor click behavior
       e.preventDefault();

       // store hash
       var hash = this.hash;

       // animate
       $('html, body').animate({
           scrollTop: $(hash).position().top - (window.innerWidth > 440 ? headerHeight : 20)
         }, 300, function(){

           // when done, add hash to url
           // (default click behaviour)
           //window.location.hash = hash;
         });

    });
  



  })


})();